import React from "react";
import { Tooltip } from "react-tippy";
import { Button, notification } from "antd";
import { BorderOutlined, MinusSquareFilled } from "@ant-design/icons";
import PopUp from "./PopUp";
import PlansPopUp from "./PlansPopUp";
import { checkMetricHistoryViolation } from "../utils/checkActivePlanViolations";
import "react-tippy/dist/tippy.css";

class MonthTableDay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isPlansOpen: false,
    };
  }

  setDate = () => {
    console.log(this.props.fullDate);
    const isShare = this.props.isShare;
    const isOutOfActivePlanHistory = checkMetricHistoryViolation(
      this.props.fullDate,
      this.props.activePlanHistoryPeriod,
      isShare
    );
    if (isOutOfActivePlanHistory && !isShare) {
      this.showNotif(
        `${this.props.activePlanName} Plan`,
        `You can't see the history for this day.`
      );
    } else if (!isShare) {
      this.props.onDateClicked(this.props.checkId, this.props.fullDate);
    }
  };

  showNotif = (title, text) => {
    const btn = (
      <Button
        onClick={() => {
          notification.close();
          this.setState({ isPlansOpen: true });
        }}
        type="primary"
        size="small"
      >
        Upgrade Plan
      </Button>
    );
    notification.config({
      duration: 10,
      placement: "bottomLeft",
    });
    const args = {
      message: title,
      description: text,
      btn,
    };
    notification.warn(args);
  };

  render() {
    const isShare = this.props.isShare;
    const isOutOfActivePlanHistory = checkMetricHistoryViolation(
      this.props.fullDate,
      this.props.activePlanHistoryPeriod,
      isShare
    );

    let jsx = <BorderOutlined />;
    let status = "";
    let toolTipData = "";
    if (!this.props.notInMonth) {
      jsx = <BorderOutlined />;
      status = "disabled";
    }
    if (this.props.monthlyUptimes) {
      jsx = (
        <MinusSquareFilled
          onClick={this.setDate}
          style={{ cursor: "pointer" }}
        />
      );
      toolTipData = `${formatMinute(
        this.props.monthlyUptimes.downtime_minutes
      )} down time`;
      if (this.props.monthlyUptimes.downtime_minutes === 0) {
        status = "green";
        toolTipData = "No down time";
      } else if (this.props.monthlyUptimes.downtime_minutes < 15) {
        status = "yellow";
      } else {
        status = "red";
      }
      toolTipData =
        toolTipData + ", " + this.props.monthlyUptimes.apdex_percent;
    }
    if (this.props.date) {
      toolTipData = this.props.date + ": " + toolTipData + "% Apdex";
    }
    return (
      <React.Fragment>
        <Tooltip
          title={toolTipData}
          size="big"
          theme="light"
          arrow="true"
          delay={300}
          disabled={!toolTipData}
        >
          <div
            className={`month-table--day ${status} ${
              isOutOfActivePlanHistory ? "violated" : ""
            }`}
          >
            {jsx}
          </div>
        </Tooltip>

        {this.state.isPlansOpen && (
          <PopUp
            closePopUp={this.closePlans}
            closeOnOutClick={false}
            style={{ zIndex: 50 }}
          >
            <PlansPopUp />
          </PopUp>
        )}
      </React.Fragment>
    );
  }
}

const formatMinute = (minute) => {
  const hour = parseInt(minute / 60, 10);
  const min = minute % 60;
  if (hour < 1) {
    return `${min}m`;
  }
  return `${hour}h ${min}m`;
};

export default MonthTableDay;
